import { SxProps, Theme } from "@mui/material";

export const containerSx: SxProps<Theme> = {
  py: 2,
};

export const instructionSx: SxProps<Theme> = {
  mb: 2,
  fontWeight: 400,
  fontStyle: "normal",
  fontSize: "16px",
  lineHeight: "22px",
  letterSpacing: 0,
  verticalAlign: "middle",
};

export const groupTitleSx: SxProps<Theme> = {
  mb: 1,
  fontWeight: 700,
  fontStyle: "bold",
  fontSize: "16px",
  lineHeight: "20px",
  letterSpacing: 0,
  verticalAlign: "middle",
};

export const fieldLabelSx: SxProps<Theme> = {
  flexShrink: 0,
  whiteSpace: "nowrap",
  fontWeight: 400,
  fontStyle: "regular",
  fontSize: "16px",
  lineHeight: "22px",
  letterSpacing: 0,
  verticalAlign: "middle",
};

export const fileNameSx: SxProps<Theme> = {
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontWeight: 400,
  fontStyle: "regular",
  fontSize: "16px",
  lineHeight: "22px",
  letterSpacing: 0,
  verticalAlign: "middle",
  color: "#96A3A8",
};
